import React, { useCallback, useEffect } from 'react';
import { Form } from 'react-final-form';

import SecurityPageWrapper from '../security-page-wrapper/SecurityPageWrapper';
import { changePasswordYupValidation } from '../validation';
import ChangePasswordForm from './ChangePasswordForm';
import validate from '../../utils/validate';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { changeUserPassword } from '../../redux/security/securityActions';

const ChangePassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const changePasswordToken = useSelector((state) => state.securityNew.changePasswordToken);
  const changePasswordInitialValus = {
    newPassword: '',
    repeatPassword: '',
    generatedPassword: '',
  };

  const handleUpdatePassword = useCallback(
    (values) => {
      dispatch(changeUserPassword(values));
    },
    [dispatch],
  );

  useEffect(() => {
    if (!changePasswordToken) {
      navigate('/login');
    }
  }, [changePasswordToken]);

  return (
    <SecurityPageWrapper>
      <Form
        initialValues={changePasswordInitialValus}
        onSubmit={handleUpdatePassword}
        validate={(values) => validate(values, changePasswordYupValidation())}
        subscription={{ submitting: true, pristine: true }}
        render={({ handleSubmit }) => <ChangePasswordForm handleSubmit={handleSubmit} />}
      />
    </SecurityPageWrapper>
  );
};

export default ChangePassword;
